/**
 * `labor.device_session.page` values for Pre-Pack (queue vs carton job), matching the Clamp QC split between
 * list/settings (`clamp-qc`) and job workspace (`clamp-qc-job:…`).
 */

/** Queue and non-carton Pre-Pack routes: not a carton job clock context. */
export const PREPACK_LIST_LABOR_PAGE = "pre-pack";

export function prePackLaborPageKeyForCarton(shipmentId: number, cartonNumber: number): string {
  return `pre-pack-job:${shipmentId}:${cartonNumber}`;
}

/**
 * Expected labor page for the current URL — used with `hubLaborExpectedPageFromPathname` for the account menu hourglass
 * and with Pre-Pack carton `LaborTracker` clock-in.
 */
export function prePackLaborExpectedPageFromPathname(pathname: string): string {
  const match = pathname.match(/^\/shipping\/pre-pack\/shipments\/(\d+)\/cartons\/(\d+)/);
  if (match) {
    const shipmentId = Number.parseInt(match[1] ?? "", 10);
    const cartonNumber = Number.parseInt(match[2] ?? "", 10);
    if (Number.isFinite(shipmentId) && shipmentId > 0 && Number.isFinite(cartonNumber) && cartonNumber > 0) {
      return prePackLaborPageKeyForCarton(shipmentId, cartonNumber);
    }
  }
  if (pathname.startsWith("/shipping/pre-pack")) {
    return PREPACK_LIST_LABOR_PAGE;
  }
  return PREPACK_LIST_LABOR_PAGE;
}
